// extracted by mini-css-extract-plugin
module.exports = {"text":"AuthRecovery_text__3yxte","timer":"AuthRecovery_timer__36TSg","link":"AuthRecovery_link__1YBGs"};